import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase/app";
import "firebase/auth";
import Home from "../views/Home.vue";
import NoGame from "../views/NoGame.vue";
import Live from "../views/Live.vue"


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/live",
    name: "Live",
    component: Live
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("../views/forgot.vue")
  },
  {
    path: "/nogame",
    name: "No Game",
    component: NoGame
  },
  {
    path: "/admin",
    name: "Admin",
    meta: {
      auth: true
    },
    component: () => import("../views/Admin.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach(async (to, from, next) => {
 
  if (!to.meta.auth) {
    return next();
  }
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      return next();
    }
    next("/login");
  });
});


export default router;
